import React, { FC } from 'react';
import { AnalyticsPagesVisitedProps } from './AnalyticsPagesVisitedProps';
import { BarChartPro } from '@mui/x-charts-pro/BarChartPro';
import AnalyticsLoader from '../AnalyticsLoader';

const AnalyticsPagesVisited: FC<AnalyticsPagesVisitedProps> = ({
  data,
  loading,
}) => {
  return (
    <AnalyticsLoader loading={loading}>
      <BarChartPro
        dataset={data}
        xAxis={[
          {
            scaleType: 'band',
            dataKey: 'location',
            tickLabelStyle: { angle: -45 },
          },
        ]}
        series={[
          {
            dataKey: 'number',
            label: 'Times Visited',
          },
        ]}
        slots={{
          noDataOverlay: () => null,
        }}
      />
    </AnalyticsLoader>
  );
};

export default AnalyticsPagesVisited;
